// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gFoy","colMin":"styles_colMin__1neBc"};